import Pair from './Pair';
import Checkboxes from './Checkbox';
import Question from './Question';
import HeaderQuestion from './HeaderQuestion';
import Radiobutton from './Radiobutton';
import Sliderbar from './Sliderbar';
import NextQuestionButton from './NextQuestionButton';
import Header from './Header';
import End from './End';
import PageNotFound from './PageNotFound';
import Interview from './Interview';
import TextForm from './TextForm';

export {
  Pair,
  Checkboxes,
  Question,
  Radiobutton,
  Sliderbar,
  NextQuestionButton,
  Header,
  HeaderQuestion,
  End,
  PageNotFound,
  Interview,
  TextForm
};



// WEBPACK FOOTER //
// ./src/comparison/components/index.js